import React from "react";
import ImgAbout from "../static/img/cl.gif";

import { Fade } from "react-reveal";

export default class AboutMe extends React.Component {
  render() {
    return (
      <Fade left duration={1000} distance="20px">

      <div className="container about-me remove-padding d-flex flex-column flex-lg-row">
        <div className="about-left-side m-4 col-lg-6 about-me-texts">
        <img
              alt="about me"
              src={ImgAbout}
              width="540" height="350" 
             />
               </div>
        <div className=" m-4">
          <div className="about-me-texts">
          <br></br>
          <br></br>

            <span className="txt-about"> About me </span>

            <br></br>

            <p >
              A very motivated software engineer & graphic designer based in
              Monastir , TN . I am passionate about AI and always reading and
              trying new technologies trends .
       I enjoy creating things  whether that be websites, applications, or anything in between.
              <br></br>
              After a remote internship with ARCH4IE and  graduating from Polytechnic school of Monastir in
           August 2019 , I am trying to perform my skills  , continuing my research and learning spirit,
              working  on  plenty of   meaningful projects  with a variety of frameworks & tools .
            </p>
             

            <p>
             In fact , i spend a large amount of my free time  exploring reading the latest technology
              advancements in the development world.{" "}
            </p>
          </div>
          {/*<div className="about-btn-container mt-5 d-flex flex-column flex-sm-row align-items-center">*/}
          {/*<span className="btn-rounded m-2 col-6 text-center">hire me</span>*/}
          {/*<span className="btn-none-rounded m-2 col-6 text-center">see my resume</span>*/}
          {/*</div>*/}
        </div>
      </div>
       </Fade>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutMe.js